import type { FC } from 'react';

import { useIntl } from 'react-intl';

import { Button, Modal } from 'antd';
import { MailOutlined } from '@ant-design/icons';

import IntlMessages from '@src/util/IntlMessages';

import styles from './styles.module.less';

export type WorkJourneyRejectedChangeNotifiedModalProps = {
  open: boolean;
  onBackToStart: () => void;
};

export const WorkJourneyRejectedChangeNotifiedModal: FC<
  WorkJourneyRejectedChangeNotifiedModalProps
> = ({ open, onBackToStart }) => {
  const intl = useIntl();

  return (
    <Modal
      open={open}
      onCancel={onBackToStart}
      closable={false}
      destroyOnClose
      width={480}
      className={styles.modal}
      footer={null}
      centered
    >
      <div className={styles.content}>
        <div className={styles.iconWrap} aria-hidden>
          <MailOutlined className={styles.icon} />
        </div>
        <h2 className={styles.title}>
          <IntlMessages id="workJourney.management.resolve.notified.title" />
        </h2>
        <p className={styles.description}>
          <IntlMessages id="workJourney.management.resolve.notified.description" />
        </p>
        <Button type="primary" block size="large" onClick={onBackToStart}>
          {intl.formatMessage({ id: 'workJourney.management.resolve.notified.back' })}
        </Button>
      </div>
    </Modal>
  );
};
